export  default {
  setActiveDevices(state, payload) {
    state.activeDevices = payload;
  },
  setContainerDevices(state, payload) {
    state.containerDevices = payload;
  },
  
};